/** Trabajadores de la empresa (T027 · US1). */
import { createFileRoute } from '@tanstack/react-router';

import { WorkersPage } from '../../features/workers/workers-page';

export const Route = createFileRoute('/_app/trabajadores')({
  component: WorkersPage,
});
